import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, Label, Input, Card, CardBody,
    Container, Button, FormFeedback, InputGroup
} from "reactstrap";
import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

const PromoCodesCreate = () => {
    const [title, setTitle] = useState('');
    const [code, setCode] = useState('');
    const [value, setValue] = useState('');
    const [type, setType] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const navigate = useNavigate();

    const generateCode = () => {
        const randomCode = "MOEEN-" + Math.random().toString(36).substring(2, 10).toUpperCase();
        setCode(randomCode);
    };

    const validateFields = () => {
        const e = {};
        if (!title.trim()) e.title = "Title is required";
        if (!code) e.code = "Code is required";
        if (!value) e.value = "Value is required";

        if (type === "percent" && Number(value) > 100) {
            e.value = "Percent value cannot be greater than 100";
        }

        if (!startDate) e.startDate = "Start date is required";
        if (!endDate) e.endDate = "End date is required";

        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);

        if (!validateFields()) return;

        setLoading(true);

        const formData = new FormData();
        formData.append('name', title);
        formData.append('code', code);
        formData.append('value', value);
        formData.append('type', type);
        formData.append('start_date', startDate ? startDate.toISOString().split("T")[0] : "");
        formData.append('end_date', endDate ? endDate.toISOString().split("T")[0] : "");

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/refferals/create`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: formData,
            });

            const data = await response.json();

            if (response.status === 200) {
                toast.success('Refferal created successfully', { autoClose: 3000 });
                setLoading(false);
                navigate(`/refferals`);
            } else {
                setLoading(false);
                toast.error(data?.message || 'Error creating Refferal', { autoClose: 3000 });
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
            toast.error("Failed to create Refferal", { autoClose: 3000 });
        }
    };

    document.title = "Add Refferal | Moeen";

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs maintitle="Home" title="Refferals" breadcrumbItem="Add Refferal" />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            {/* Title */}
                                            <div className="mb-3">
                                                <Label>Name</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="Enter title"
                                                    value={title}
                                                    onChange={e => setTitle(e.target.value)}
                                                    invalid={isSubmitted && !!errors.title}
                                                />
                                                {isSubmitted && errors.title && (
                                                    <FormFeedback>{errors.title}</FormFeedback>
                                                )}
                                            </div>

                                            {/* Code with Generate button */}
                                            <div className="mb-3">
                                                <Label>Code</Label>
                                                <div className="d-flex">
                                                    <Input
                                                        type="text"
                                                        placeholder="Click Generate to create code"
                                                        value={code}
                                                        onChange={e => setCode(e.target.value.toUpperCase())}
                                                        invalid={isSubmitted && !!errors.code}
                                                    />
                                                    <Button
                                                        color="info"
                                                        type="button"
                                                        className="ms-2"
                                                        onClick={generateCode}
                                                    >
                                                        Generate
                                                    </Button>
                                                </div>
                                                {isSubmitted && errors.code && (
                                                    <FormFeedback className="d-block">{errors.code}</FormFeedback>
                                                )}
                                            </div>

                                            {/* Value */}
                                            <div className="mb-3">
                                                <Label>Value</Label>
                                                <Input
                                                    type="number"
                                                    placeholder="Enter value"
                                                    value={value}
                                                    onChange={e => setValue(e.target.value)}
                                                    invalid={isSubmitted && !!errors.value}
                                                />
                                                {isSubmitted && errors.value && (
                                                    <FormFeedback>{errors.value}</FormFeedback>
                                                )}
                                            </div>

                                        </Col>

                                        <Col md="6">
                                            {/* Type */}
                                            <div className="mb-3">
                                                <Label>Type</Label>
                                                <Select
                                                    value={type ? { value: type, label: type.charAt(0).toUpperCase() + type.slice(1) } : null}
                                                    onChange={(selected) => setType(selected?.value || "")}
                                                    options={[
                                                        { value: "percent", label: "Percent" },
                                                        { value: "amount", label: "Amount" }
                                                    ]}
                                                    placeholder="-- Select Promo Code Type --"
                                                    isClearable
                                                />
                                                {isSubmitted && errors.type && (
                                                    <div className="text-danger mt-1">{errors.type}</div>
                                                )}
                                            </div>

                                            <Row>
                                                <Col md="6">
                                                    <div className="mb-3">
                                                        <Label>Start Date</Label>
                                                        <InputGroup>
                                                            <Flatpickr
                                                                className="form-control d-block"
                                                                placeholder="dd M, yyyy"
                                                                value={startDate}
                                                                onChange={(date) => setStartDate(date[0])}
                                                                options={{
                                                                    altInput: true,
                                                                    altFormat: "F j, Y",
                                                                    dateFormat: "Y-m-d",
                                                                    defaultDate: new Date(),
                                                                    minDate: "today"
                                                                }}
                                                            />
                                                        </InputGroup>
                                                        {isSubmitted && errors.startDate && (
                                                            <FormFeedback>{errors.startDate}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col md="6">
                                                    <div className="mb-3">
                                                        <Label>End Date</Label>
                                                        <InputGroup>
                                                            <Flatpickr
                                                                className="form-control d-block"
                                                                placeholder="dd M, yyyy"
                                                                value={endDate}
                                                                onChange={(date) => setEndDate(date[0])}
                                                                options={{
                                                                    altInput: true,
                                                                    altFormat: "F j, Y",
                                                                    dateFormat: "Y-m-d",
                                                                    defaultDate: new Date(),
                                                                    minDate: "today"
                                                                }}
                                                            />
                                                        </InputGroup>
                                                        {isSubmitted && errors.endDate && (
                                                            <FormFeedback>{errors.endDate}</FormFeedback>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="text-end">
                                            <Button type="submit" color="primary" disabled={loading}>
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Saving...
                                                    </>
                                                ) : (
                                                    "Submit"
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default PromoCodesCreate;
